export const landingPageNodes = [
  {
    id: "158.115.118.151",
    type: "custom",
    position: { x: 600, y: 300 },
    className: "gateway-creative nodrag",
    data: { label: "158.115.118.151" },
    dragHandle: "noDrag",
  },
  {
    id: "135.127.3.223",
    type: "custom",
    className: "gateway-creative nodrag",
    position: { x: 305, y: 240 },
    data: { label: "135.127.3.223" },
    dragHandle: "noDrag",
  },
  {
    id: "219.126.205.224",
    type: "custom",
    className: "gateway-creative nodrag",
    position: { x: 485, y: 140 },
    data: { label: "219.126.205.224" },
    dragHandle: "noDrag",
  },
  {
    id: "165.172.71.197",
    type: "custom",
    className: "gateway-creative nodrag",
    position: { x: 585, y: 510 },
    data: { label: "165.172.71.197" },
    dragHandle: "noDrag",
  },
  {
    id: "210.59.227.148",
    type: "custom",
    className: "gateway-creative nodrag",
    position: { x: 245, y: 390 },
    data: { label: "210.59.227.148" },
    dragHandle: "noDrag",
  },

  {
    id: "31.32.181.182",
    type: "custom",
    className: "gateway-creative nodrag",
    position: { x: 685, y: 140 },
    data: { label: "31.32.181.182" },
    dragHandle: "noDrag",
  },
  {
    id: "243.84.74.124",
    type: "custom",
    className: "gateway-creative nodrag",
    position: { x: 795, y: 469 },
    data: { label: "243.84.74.124" },
    dragHandle: "noDrag",
  },
  {
    id: "103.27.183.59",
    type: "custom",
    className: "gateway-creative nodrag",
    position: { x: 785, y: 250 },
    data: { label: "103.27.183.59" },
    dragHandle: "noDrag",
  },
  {
    id: "29.52.143.155",
    type: "custom",
    className: "server-creative nodrag",
    position: { x: 435, y: 240 },
    data: { label: "29.52.143.155" },
    dragHandle: "noDrag",
  },
  {
    id: "155.150.188.207",
    type: "custom",
    className: "client-plugged-creative",
    position: { x: 355, y: 470 },
    data: { label: "155.150.188.207" },
  },
  {
    id: "93.175.52.45",
    type: "custom",
    className: "client-unplugged-creative",
    position: { x: 55, y: 190 },
    data: { label: "93.175.52.45" },
  },
  {
    id: "234.162.245.59",
    type: "custom",
    className: "bts-creative nodrag",
    position: { x: 415, y: 440 },
    data: { label: "234.162.245.59" },
    dragHandle: "noDrag",
  },
  {
    id: "251.40.88.159",
    type: "custom",
    className: "wifi-creative nodrag",
    position: { x: 185, y: 140 },
    data: { label: "251.40.88.159" },
    dragHandle: "noDrag",
  },
];
